import { useMemo } from 'react'

import { Box } from '@mui/material'
import { FormConfig } from '@workwave-tidal/core/form'

import { form } from './../../../../formState'

import { useController } from '../../../../hooks/useController'
import { useOnSubmit } from '../../../../hooks/useOnSubmit'

import { TestPhoneNotificationFormValues } from '@/components/modals/TestPhoneNotificationModal/types'
import { ReadyFooter } from '../../../Footer/components/ReadyFooter'
import { PhoneNumber } from './PhoneNumber'

export function ReadyBody() {
  const {
    data: { notification, values },
  } = useController()

  const submit = useOnSubmit(notification, values)

  const configs = useMemo<FormConfig<TestPhoneNotificationFormValues>>(
    () => ({
      id: 'test-phone-notification-form',
      initialValues: { phoneNumber: '' },
    }),
    [values],
  )

  return (
    <Box height={170}>
      <form.Form
        config={configs}
        requireTransaction={false}
        stopEditingOnUnmount={false}
        applyPendingFitMapOnMount={false}
        width="auto"
        onSubmit={submit}
        footer={<ReadyFooter />}
        disableScroll
        fieldsPadding="16px 0"
      >
        <PhoneNumber />
      </form.Form>
    </Box>
  )
}
